export const CATEGORIES = {
  food:        { label: '푸드트럭',    color: '#FF6B35', emoji: '🍔' },
  gallery:     { label: '갤러리/전시', color: '#9B59B6', emoji: '🎨' },
  market:      { label: '프리마켓',    color: '#E91E8C', emoji: '🛍️' },
  performance: { label: '길거리공연',  color: '#2ECC71', emoji: '🎵' },
  popup:       { label: '팝업스토어',  color: '#E74C3C', emoji: '🏪' },
  tour:        { label: '관광/행사',   color: '#3498DB', emoji: '🗺️' },
  user:        { label: '일반',        color: '#95A5A6', emoji: '💬' },
};

export const BUSINESS_CATEGORIES = [
  { key: 'food',        emoji: '🍔', label: '푸드트럭' },
  { key: 'gallery',     emoji: '🎨', label: '갤러리/전시' },
  { key: 'market',      emoji: '🛍️', label: '프리마켓' },
  { key: 'performance', emoji: '🎵', label: '길거리공연' },
  { key: 'popup',       emoji: '🏪', label: '팝업스토어' },
  { key: 'tour',        emoji: '🗺️', label: '관광/행사' },
];

export const BUSINESS_ROLES = {
  business_basic:   { label: '일반 사업자',   canPickLocation: false, canAlwaysOn: false },
  business_pro:     { label: '프로 사업자',   canPickLocation: true,  canAlwaysOn: false },
  business_premium: { label: '프리미엄 사업자', canPickLocation: true,  canAlwaysOn: true },
};